import LandingDynamicWorkflow from './landingDynamicWorkflow';

export interface LandingTableBodyProps {
  loading: boolean;
  data: LandingDynamicWorkflow[];
}

export enum LandingActionKind {
  SET_DYNAMICWORKFLOWS,
  SET_ISLOADING,
  SEARCH_DYNAMICWORKFLOWS
}

export interface LandingState {
  dynamicWorkflows: LandingDynamicWorkflow[];
  filteredWorkflows: LandingDynamicWorkflow[];
  isLoading: boolean;
}

export interface LandingAction {
  type: LandingActionKind;
  payload?: LandingDynamicWorkflow[] | boolean;
}
